export default {
  production: {
    launch: {
      outdoor: "//assets.adobedtm.com/323c24ea560f/87ce3a19f54b/launch-89990b0a95f5.min.js",
      leaf: "//assets.adobedtm.com/323c24ea560f/87ce3a19f54b/launch-89990b0a95f5.min.js",
      urban: "//assets.adobedtm.com/323c24ea560f/a9ff8797aaf9/launch-1e4fb715a4f8.min.js",
      sale: "//assets.adobedtm.com/323c24ea560f/87ce3a19f54b/launch-89990b0a95f5.min.js",
    },
  },
  preprod: {
    launch: {
      outdoor: "//assets.adobedtm.com/323c24ea560f/87ce3a19f54b/launch-89990b0a95f5.min.js",
      leaf: "//assets.adobedtm.com/323c24ea560f/87ce3a19f54b/launch-89990b0a95f5.min.js",
      urban: "//assets.adobedtm.com/323c24ea560f/a9ff8797aaf9/launch-1e4fb715a4f8.min.js",
      sale: "//assets.adobedtm.com/323c24ea560f/87ce3a19f54b/launch-89990b0a95f5.min.js",
    },
  },
  stage: {
    launch: {
      outdoor: "//assets.adobedtm.com/323c24ea560f/87ce3a19f54b/launch-b4df60b59432-staging.min.js",
      leaf: "//assets.adobedtm.com/323c24ea560f/87ce3a19f54b/launch-b4df60b59432-staging.min.js",
      urban: "//assets.adobedtm.com/323c24ea560f/a9ff8797aaf9/launch-6853f8db69db-staging.min.js",
      sale: "//assets.adobedtm.com/323c24ea560f/87ce3a19f54b/launch-b4df60b59432-staging.min.js",
    },
  },
  qa: {
    launch: {
      outdoor: "//assets.adobedtm.com/323c24ea560f/87ce3a19f54b/launch-75d11936f949-development.min.js",
      leaf: "//assets.adobedtm.com/323c24ea560f/87ce3a19f54b/launch-75d11936f949-development.min.js",
      urban: "//assets.adobedtm.com/323c24ea560f/a9ff8797aaf9/launch-5ff4e649f6d5-development.min.js",
      sale: "//assets.adobedtm.com/323c24ea560f/87ce3a19f54b/launch-75d11936f949-development.min.js",
    },
  },
};
